
import { Component, Mixins, Prop, PropSync } from "vue-property-decorator";
import { mdiGoogle, mdiMicrosoftWindows} from "@mdi/js";
import { VuetifyMixin, BAIconsMixin } from "@/mixins";
import { CalendarUrls } from '../hoc/CalendarProvider.vue';

const DefaultCalendarURLs: CalendarUrls = {
	ics: '#',
	webcal: '#',
	google: '#',
	outlook: '#',
}

@Component
export default class CalendarExportDialog extends Mixins(VuetifyMixin, BAIconsMixin) {
	@PropSync('show', { default: false, type: Boolean }) Show: boolean;
	@Prop({ default: DefaultCalendarURLs }) calendarURLs: CalendarUrls;

	mdiGoogle = mdiGoogle;
	mdiMicrosoftWindows = mdiMicrosoftWindows;


	copyClicked: boolean = false;
}
